export default __webpack_public_path__ + "static/media/Pathwhite.4ef2ade3.svg";